import { render, staticRenderFns } from "./bubble.vue?vue&type=template&id=70afa86f&scoped=true&"
import script from "./bubble.vue?vue&type=script&lang=ts&"
export * from "./bubble.vue?vue&type=script&lang=ts&"
import style0 from "./bubble.vue?vue&type=style&index=0&id=70afa86f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afa86f",
  null
  
)

export default component.exports